import reframe from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';

reframe.registerHandler('appDownload.loaded', defaultMiddlewares, (db, [data]) => {
    return db.setIn(['app_download'], data);
});
